module.exports = __webpack_public_path__ + "img/tooltip.28d50341.svg";